import React from "react";
import * as WidgetFactory from "client20/WidgetFactory";
import * as BosWebGuiServices from "data/BosWebServices/BosWebGuiServices";
import { setWaitCursor, clearWaitCursor } from "../GlobalWaitCursor/GlobalWaitCursor";
import RootWidgetContainer from "./RootWidgetContainer";

function Viewport(props) {

  const { dataSegment, sessionId, viewport, isEnabled, onResult } = props;

  const rootWidgetUi = viewport ? viewport.rootWidget : null;
  const data = viewport ? viewport.data : null;
  const viewportId = viewport ? viewport.viewportId : null;

  const handleStartWork = async widgetRef => {
    setWaitCursor();
    //console.log("StartWork triggered");
    return await BosWebGuiServices.fetchStartWork(dataSegment.authToken, sessionId, viewportId, widgetRef)
      .then(result => {
        console.log("StartWork result: ", result);
        onResult(result);
        clearWaitCursor();
        return true;
      })
      .catch(error => {
        console.error("StartWork result: ", error);
        clearWaitCursor();
        return false;
      });
  };

  const handleWriteBack = async (widgetRef, content) => {
    setWaitCursor();
    //console.log("WriteBack triggered");
    return await BosWebGuiServices.fetchWriteBack(dataSegment.authToken, sessionId, viewportId, widgetRef, content)
      .then(result => {
        console.log("WriteBack result: ", result);
        onResult(result);
        clearWaitCursor();
        return true;
      })
      .catch(error => {
        console.error("WriteBack result: ", error);
        clearWaitCursor();
        return false;
      });
  };

  const handleDoAction = async (widgetRef, actionId, content) => {
    setWaitCursor();
    //console.log("DoAction triggered");
    return await BosWebGuiServices.fetchDoAction(dataSegment.authToken, sessionId, viewportId, widgetRef, actionId, content ? content : "NOTDEFINED")
      .then(result => {
        console.log("DoAction result: ", result);
        onResult(result);
        clearWaitCursor();
        return true;
      })
      .catch(error => {
        console.error("DoAction result: ", error);
        clearWaitCursor();
        return false;
      });
  };

  const handleGetAutocompleteSuggestions = async (autocompleteId, prefix, maxResults) => {
    setWaitCursor();
    //console.log("GetAutocompleteSuggestions triggered");
    return await BosWebGuiServices.fetchGetAutocompleteSuggestions(dataSegment.authToken, sessionId, autocompleteId, prefix, maxResults)
      .then(result => {
        console.log("GetAutocompleteSuggestions result: ", result);
        clearWaitCursor();
        return result;
      })
      .catch(error => {
        console.error("GetAutocompleteSuggestions result: ", error);
        clearWaitCursor();
        return null;
      });
  };

  const handleGetContextActions = async (widgetRef) => {
    setWaitCursor();
    //console.log("GetContextActions triggered");
    return await BosWebGuiServices.fetchGetContextActions(dataSegment.authToken, sessionId, viewportId, widgetRef)
      .then(result => {
        console.log("GetContextActions result: ", result);
        clearWaitCursor();
        return result;
      })
      .catch(error => {
        console.error("GetContextActions result: ", error);
        clearWaitCursor();
        return null;
      });
  };

  const handleCreateChildWidget = childWidgetUi => {
    return renderWidget(childWidgetUi);
  };

  const renderRootWidget = () => {
    return renderWidget(rootWidgetUi);
  }

  const renderWidget = (widgetUi) => {
    return WidgetFactory.createWidget(dataSegment, widgetUi, data, 
      handleCreateChildWidget, handleWriteBack, handleDoAction, handleStartWork, handleGetAutocompleteSuggestions, handleGetContextActions);
  }

  const renderViewport = () => {
    if (!viewport) return;
    return (
      <RootWidgetContainer isEnabled={isEnabled}>
        {renderRootWidget()}
      </RootWidgetContainer>
    );
  };

  return renderViewport();
}

export default Viewport;
